// @flow
import React, { PureComponent } from "react";
import { noop } from "lodash";
import type { BinaryFn } from "@tvg/types/Functional";
import type {
  RaceCardBettingInterest,
  RaceTypeCodeEnum
} from "@tvg/types/Race";
import MessageBox from "../../_molecule/MessageBox";
import RunnerList, { type Selections } from "../../_organism/RunnerList";
import { EmptyStateContainer } from "../TrackMasterPicks/styled-components";
import RunnerContainer from "./styled-components";

type Props = {
  /**
   * Array of the Race Betting Interests
   */
  bettingInterests: RaceCardBettingInterest[],
  /**
   * Race type code
   */
  raceTypeCode: RaceTypeCodeEnum,
  /**
   * Array with the current selections of the RaceCard
   */
  selections: Selections,
  /**
   * Flag to activate a key column
   */
  isKey: boolean,
  /**
   * Flag to activate the leg layout
   */
  isLeg: boolean,
  /**
   * Number of selection columns
   */
  numColumns: number,
  /**
   * Calback to run when user selects a runner
   */
  onRunnerSelect: BinaryFn<string, number, mixed>,
  /**
   * selected leg on pick bets
   */
  selectedLeg: number,
  /**
   * Track data source
   */
  trackDataSource: string,
  /**
    is track master pick
   */
  isTrackMasterPick: boolean,
  /**
    is numberFire pick
   */
  isNumberFirePick: boolean,
  /**
    Empty state message
   */
  emptyStateMessage: string
};

export default class TrackMasterPicksWagerable extends PureComponent<Props> {
  static defaultProps = {
    bettingInterests: [[]],
    raceTypeCode: "T",
    selections: [[]],
    numColumns: 1,
    isLeg: false,
    isKey: false,
    onRunnerSelect: noop,
    selectedLeg: 0,
    trackDataSource: "",
    isTrackMasterPick: false,
    isNumberFirePick: false,
    emptyStateMessage: ""
  };

  render() {
    const {
      bettingInterests,
      onRunnerSelect,
      raceTypeCode,
      selections,
      numColumns,
      isLeg,
      isKey,
      selectedLeg,
      trackDataSource,
      isTrackMasterPick,
      isNumberFirePick,
      emptyStateMessage
    } = this.props;

    return bettingInterests.length > 0 ? (
      <RunnerContainer>
        <RunnerList
          runners={bettingInterests}
          selections={selections}
          onRunnerSelect={onRunnerSelect}
          raceTypeCode={raceTypeCode}
          numColumns={numColumns}
          isKey={isKey}
          isLeg={isLeg}
          leg={selectedLeg}
          trackDataSource={trackDataSource}
          isTrackMasterPick={isTrackMasterPick}
          isNumberFirePick={isNumberFirePick}
        />
      </RunnerContainer>
    ) : (
      <EmptyStateContainer>
        <MessageBox
          type="infoNoBackground"
          message={emptyStateMessage}
          isVertical
          hasIcon
        />
      </EmptyStateContainer>
    );
  }
}
